'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import { AccessProvider } from './access-context';
import { AuthLifecycleCoordinator } from '@/src/auth/auth-lifecycle-coordinator';
import { VoiceRootBoundary } from '@/src/features/contact-center/voice/voice-root-boundary';

const publicRoutes = new Set(['/login', '/privacy-policy']);

export function AccessProviderBoundary({ children }: { children: ReactNode }) {
  const pathname = usePathname();

  if (pathname && publicRoutes.has(pathname)) {
    return <>{children}</>;
  }

  return (
    <AuthLifecycleCoordinator>
      <AccessProvider>
        <VoiceRootBoundary>{children}</VoiceRootBoundary>
      </AccessProvider>
    </AuthLifecycleCoordinator>
  );
}
